import { saveData } from "services/api/saveData"
import { BillingData } from "../BillingTypes"

// Creates a stripe customer or updates it
export const createStripeCustomer = async (
    environmentHash: string, 
    billingData: BillingData
) => {
    try {
        // Send the request to the server
        const response = await saveData({
            apiUrl: `post_stripe_customer/${environmentHash}`,
            method: 'post',
            data: {
                company_name: billingData.company_name,
                email: billingData.email,
            }
        });

        // Throw error if the customer is not created
        if (response?.status !== 200 && response?.status !== 201) {
            throw new Error("Failed to create Stripe Customer")
        };

        // Return the stripe customer id
        return response.data.stripe_customer_id;

    } catch (error) {
        console.error("Error creating/updating Stripe Customer:", error);
        return null;
    }
};